export default {
  API_ENV: 'prod',
  API_COURSE: 'https://time.geekbang.org/serv/v2/explore/list'
}



// WEBPACK FOOTER //
// ./src/config/prod.js